(function (Drupal, $, once) {
  Drupal.behaviors.accordion = {
    attach: function (context, settings) {
      "use strict";

      // Set 'document' to 'context' if Drupal
      var accordionTerm = document.querySelectorAll(".accordion-term");
      var accordionDef = document.querySelectorAll(".accordion-def");

      // If javascript, hide accordion definition on load
      function jsCheck() {
        for (var i = 0; i < accordionDef.length; i++) {
          if (accordionDef[i].classList) {
            accordionDef[i].classList.add("active");
          } else {
            accordionDef[i].className += " active";
          }
        }
      }

      //detect offscreen function
      jQuery.expr.filters.offscreen = function (el) {
        var rect = el.getBoundingClientRect();
        return (
          rect.x + rect.width < 0 ||
          rect.y + rect.height < 0 ||
          rect.x > window.innerWidth ||
          rect.y > window.innerHeight
        );
      };

      jsCheck();

      $(once('accordion-wrapper-once', ".paragraph-accordion__title-wrapper .open-all"))
        .on("click", function () {
          $(this)
            .parent()
            .siblings(".accordion-item__wrapper")
            .find(".accordion-term")
            .addClass("is-active")
            .siblings(".accordion-def")
            .stop()
            .slideDown(300);
        });

      for (var i = 0; i < accordionTerm.length; i++) {
        $(accordionTerm[i])
          .off("click")
          .on("click", function (e) {
            var className = "is-active";

            if (this.classList) {
              var toggleAccordion = function (elem) {
                $(elem)
                  .parents(".accordion-item")
                  .siblings()
                  .find(".accordion-term")
                  .removeClass(className)
                  .siblings(".accordion-def")
                  .stop()
                  .slideUp(300);
                $(elem)
                  .siblings(".accordion-def")
                  .stop()
                  .slideToggle(300, function () {
                    if ($(elem).is(":offscreen")) {
                      $(elem)
                        .get(0)
                        .scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                    if ($(elem).offset().top - $(window).scrollTop() < 100) {
                      $("html, body")
                        .stop()
                        .animate({
                          scrollTop:
                            $(elem).offset().top -
                            16 -
                            $("#global-header").height(),
                        });
                    }
                  });
              };
              toggleAccordion(this);
              this.classList.toggle(className);
            } else {
              var classes = this.className.split(" ");
              var existingIndex = classes.indexOf(className);

              if (existingIndex >= 0) {
                classes.splice(existingIndex, 1);
              } else {
                classes.push(className);
              }
              this.className = classes.join(" ");
            }
            e.preventDefault();
          });
      }
    }, //attach
  };
}(Drupal, jQuery, once));

